<template>
  <v-data-table :items="items" hide-actions>
    <template v-slot:headers>
      <tr class="headerRow grey lighten-3">
        <th>キャンペーン予算期間</th>
      </tr>
    </template>
    <template v-slot:items="{ item }">
      <tr
        @click="$emit('input', item)"
        :class="{ 'blue lighten-2 white--text': isSelected(item) }"
        class="itemRow"
      >
        <td>
          <AppWarning
            :warningMessages="warningMessages(item)"
            :errorMessages="errorMessages(item)"
          />
          {{ dateFormat(item.startTime) }} 〜 {{ dateFormat(item.endTime) }}
        </td>
      </tr>
    </template>
    <template slot="no-data">
      <td colspan="2">
        <div class="text-xs-center">
          キャンペーン予算が設定されていません。<br />
          <a @click="$emit('changeBudgetSetting')">予算設定</a>
          から予算を設定してください。
        </div>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { css } from 'emotion'
import dayjs from 'dayjs'
import CreativeScheduleValidation from '@/models/CampaignOperation/Form/CreativeScheduleValidation'
import AppWarning from '@/components/App/AppWarning'

export default {
  name:
    'CampaignModalPageCreativeModeCampaignWithSchedulesCampaignBudgetPeriodTable',
  components: { AppWarning },
  props: {
    value: {
      type: Object,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    dateFormat(dateTime) {
      return dayjs(dateTime).format('YYYY-MM-DD HH:mm')
    },
    isSelected(item) {
      return this.value && this.value.tempId === item.tempId
    },
    icon(item) {
      if (item.hasWarning) {
        return 'warning'
      } else {
        return ''
      }
    },
    iconStyles(item) {
      return [
        css`
          width: 30px;
        `,
        {
          'yellow--text text--darken-2': item.hasWarning,
        },
      ]
    },
    warningMessages(campaignBudget) {
      return CreativeScheduleValidation.getWarningMessagesByCampaignBudget(
        campaignBudget,
      )
    },
    errorMessages(campaignBudget) {
      return CreativeScheduleValidation.getErrorMessages(campaignBudget)
    },
  },
}
</script>

<style scoped lang="scss">
.headerRow {
  height: 33px;
  th {
    padding: 0 8px !important;
    text-align: left;
  }
}

.itemRow {
  cursor: pointer;

  td {
    padding: 0 !important;
  }
}
</style>
